(function ($) {
  //Jquery
})(jQuery);

//Vanilla JS

gsap.registerPlugin(SplitText);
const heroCarousels = document.querySelectorAll(".hero-carousel");
if (heroCarousels) {
  heroCarousels.forEach(hero => {
    const h2 = hero.querySelector(".hero-carousel__content h1");
    const heroParagraph = hero.querySelector(".hero-carousel__content p");
    const split = new SplitText(h2, {
      type: "words"
    });
    gsap.set(split.words, {
      opacity: 0,
      y: 40
    });
    gsap.set(heroParagraph, {
      opacity: 0,
      y: 40
    });
    setTimeout(() => {
      gsap.to(split.words, {
        y: 0,
        opacity: 1,
        stagger: 0.15,
        duration: 0.8,
        ease: "power2.out"
      });
      gsap.to(heroParagraph, {
        y: 0,
        opacity: 1,
        duration: 0.8,
        delay: 0.4,
        ease: "power2.out"
      });
    }, 600);
  });
}
heroCarousels.forEach(hero => {
  const swiperEl = hero.querySelector(".hero-carousel__swiper");
  if (!swiperEl) return;
  new Swiper(swiperEl, {
    speed: 800,
    spaceBetween: 0,
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: hero.querySelector(".swiper-pagination"),
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + '<svg viewBox="0 0 40 40">' + '<circle class="bullet-bg" cx="20" cy="20" r="18"></circle>' + '<circle class="bullet-progress" cx="20" cy="20" r="18"></circle>' + "</svg>" + "</span>";
      }
    },
    autoplay: {
      delay: 5000
    },
    on: {
      init: function () {},
      autoplayTimeLeft(s, time, progress) {
        const activeBullet = hero.querySelector(".swiper-pagination-bullet-active .bullet-progress");
        if (activeBullet) {
          const r = 18;
          const circumference = 2 * Math.PI * r;
          activeBullet.style.strokeDasharray = circumference;
          activeBullet.style.strokeDashoffset = circumference * progress;
        }
      }
    }
  });
});
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
const smootherContainer = document.querySelector("#smooth-wrapper");
let smoother;
if (window.innerWidth > 900 && smootherContainer) {
  smoother = ScrollSmoother.create({
    smooth: 2,
    effects: true,
    normalizeScroll: true
  });
}

// Interceptar los enlaces ancla para que ScrollSmoother se encargue del scroll
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
  anchor.addEventListener("click", function (e) {
    const url = new URL(this.href, window.location.href);
    // Verificar si el enlace es a la misma página y tiene un hash
    if (url.pathname === window.location.pathname && url.hash && url.hash !== "#") {
      const targetElement = document.querySelector(url.hash);
      if (targetElement) {
        e.preventDefault();
        // Hace scroll suave hasta el elemento destino usando ScrollSmoother
        // Puedes agregar un offset si el header tapa el contenido, ej: "top top+=100"
        if (smoother) {
          smoother.scrollTo(targetElement, true, "top top");
        } else {
          const topOffset = targetElement.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({
            top: topOffset,
            behavior: "smooth"
          });
        }
      }
    }
  });
});
const revealWipe = gsap.utils.toArray(".reveal-wipe");
if (window.innerWidth > 900) {
  revealWipe.forEach(element => {
    gsap.from(element, {
      clipPath: "inset(0 100% 0 0)",
      duration: 1,
      ease: "power2.out",
      scrollTrigger: {
        trigger: element,
        start: "top 70%",
        toggleActions: "play none none none"
      }
    });
  });
}
const carouselText = new Swiper(".carousel-text .swiper", {
  speed: 600,
  spaceBetween: 0,
  loop: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  autoplay: {
    delay: 5000
  }
});

// Interactive Map Scene
const interactiveMaps = document.querySelectorAll(".interactive-map");
interactiveMaps.forEach(map => {
  const bg = map.querySelector(".interactive-map__bg");
  const bgImg = bg.querySelector("img");
  const zoomedBg = map.querySelector(".interactive-map__zoomed-bg");
  const infoDots = map.querySelector(".interactive-map__info-dots");
  const content = map.querySelector(".interactive-map__content");
  const heading = map.querySelector(".interactive-map__heading");
  const body = map.querySelector(".interactive-map__body");
  const mapCard = map.querySelector(".map-card");
  const fg = map.querySelector(".interactive-map__fg");
  const mapDots = map.querySelector(".map-dots");
  if (window.innerWidth > 900) {
    gsap.set([zoomedBg, infoDots, mapCard, mapDots], {
      autoAlpha: 0
    });
    gsap.set(heading, {
      y: 40,
      clipPath: "inset(0 100% 0 0)"
    });
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: map,
        start: "top top",
        end: "+=3000",
        pin: true,
        scrub: 1
      }
    });
    ScrollTrigger.create({
      trigger: map,
      start: "top top",
      end: () => `+=${3000 + window.innerHeight}`,
      onToggle: self => {
        const header = document.getElementById("header");
        if (header) {
          header.classList.toggle("header-hide", self.isActive);
        }
      }
    });
    tl.to(bgImg, {
      scale: 2,
      transformOrigin: "50% 50%",
      opacity: 0,
      duration: 2,
      ease: "power2.inOut"
    }).to(zoomedBg, {
      opacity: 1,
      autoAlpha: 1,
      duration: 2,
      scale: 2,
      transformOrigin: "50% 50%",
      ease: "power2.inOut"
    }, "<").to(heading, {
      y: 0,
      clipPath: "inset(0 0% 0 0)",
      duration: 2
    }, "<").to(mapCard, {
      opacity: 1,
      y: 0,
      autoAlpha: 1,
      duration: 2
    }, "<").to({}, {
      duration: 0.5
    }).to(infoDots, {
      opacity: 1,
      autoAlpha: 1,
      duration: 2
    }).to(mapDots, {
      autoAlpha: 1,
      duration: 2,
      pointerEvents: "auto"
    }).to(zoomedBg, {
      opacity: 0,
      autoAlpha: 0,
      duration: 2
    }, "<").to({}, {
      duration: 1.5
    });
  } else {
    // Para móviles, aseguramos que elementos ocultos por defecto tengan opacidad
    gsap.set([bgImg, zoomedBg, infoDots, mapCard, mapDots, heading], {
      autoAlpha: 1,
      clearProps: "all"
    });
  }

  // --- Mobile Dots Carousel ---
  const mapDotsElements = map.querySelectorAll(".map-dot");
  const dotsCarouselEl = map.querySelector(".map-dots-carousel");
  if (dotsCarouselEl && mapDotsElements.length > 0) {
    const dotsSwiper = new Swiper(dotsCarouselEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      speed: 400,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      on: {
        slideChange: function () {
          // Activar el dot correspondiente
          if (window.innerWidth <= 900) {
            mapDotsElements.forEach(d => d.classList.remove("active"));
            const currentDot = map.querySelector(`.map-dot[data-index="${this.activeIndex}"]`);
            if (currentDot) {
              currentDot.classList.add("active");
            }
          }
        }
      }
    });

    // Sincronizar click en dot con el swiper
    mapDotsElements.forEach(dot => {
      dot.addEventListener("click", () => {
        const index = parseInt(dot.getAttribute("data-index"));
        if (!isNaN(index) && window.innerWidth <= 900) {
          dotsSwiper.slideTo(index);
        }
      });
    });

    // Set initial active state
    if (window.innerWidth <= 900) {
      mapDotsElements.forEach(d => d.classList.remove("active"));
      const initialDot = map.querySelector('.map-dot[data-index="0"]');
      if (initialDot) initialDot.classList.add("active");
    }
  }
});

// ─── Timeline Horizontal Scroll ───────────────────────────────────────────────
const timelineSection = document.querySelector(".timeline");
if (timelineSection && window.innerWidth > 900) {
  const timelineContent = timelineSection.querySelector(".timeline__content");
  const timeYears = gsap.utils.toArray(".time-year__item", timelineSection);
  const yearTitles = gsap.utils.toArray(".time-year__title", timelineSection);

  // Todos los items y títulos empiezan invisibles
  gsap.set(timeYears, {
    opacity: 0,
    x: 140
  });
  gsap.set(yearTitles, {
    opacity: 0,
    y: 80
  });
  gsap.set(".timeline__line-progress", {
    scaleX: 0,
    transformOrigin: "left center"
  });
  const getTotalScrollWidth = () => timelineContent.scrollWidth - timelineSection.offsetWidth;
  const SCROLL_DUR = 10;
  const tlTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: timelineSection,
      start: "top top",
      end: () => `+=${getTotalScrollWidth()}`,
      pin: true,
      scrub: 1.2,
      anticipatePin: 1,
      invalidateOnRefresh: true
    }
  });
  tlTimeline.to(timelineContent, {
    x: () => -getTotalScrollWidth(),
    ease: "none",
    duration: SCROLL_DUR
  }).to(".timeline__line-progress", {
    scaleX: 1,
    ease: "none",
    duration: SCROLL_DUR
  }, "<").to({}, {
    duration: 0.5
  });

  // Revelación individual para los títulos de los años
  yearTitles.forEach(title => {
    gsap.to(title, {
      opacity: 0.5,
      y: 0,
      ease: "none",
      scrollTrigger: {
        trigger: title,
        containerAnimation: tlTimeline,
        start: "left 70%",
        end: "left 55%",
        scrub: true
      }
    });
  });

  // Revelación individual para los items
  timeYears.forEach(item => {
    gsap.to(item, {
      opacity: 1,
      x: 0,
      ease: "none",
      // Usamos "none" para que se sienta perfectamente ligado al scroll
      scrollTrigger: {
        trigger: item,
        containerAnimation: tlTimeline,
        start: "left 95%",
        // Comienza casi al entrar
        end: "left 70%",
        // Termina de revelarse un poco después
        scrub: true // Esto hace que sea progresiva con el scroll
      }
    });
  });
}
const imageVideo = document.querySelectorAll(".image-text__main-image");
imageVideo.forEach(item => {
  const video = item.querySelector("video");
  const playButton = item.querySelector(".play-button");
  const cover = item.querySelector(".video-cover");
  if (playButton) {
    playButton.addEventListener("click", () => {
      video.play();
      playButton.style.display = "none";
      video.controls = true;
      cover.style.display = "none";
    });
  }
});
const bannerCards = document.querySelectorAll(".banner-card");
if (window.innerWidth > 640) {
  bannerCards.forEach(card => {
    card.addEventListener("click", () => {
      if (card.classList.contains("open")) {
        card.classList.remove("open");
      } else {
        card.classList.add("open");
        bannerCards.forEach(otherCard => {
          if (otherCard !== card) {
            otherCard.classList.remove("open");
          }
        });
      }
    });
  });
}

// Banner-cards carousel (≤ 640px)
if (window.innerWidth <= 640) {
  const bannerCardsSwiper = document.querySelector(".banner-cards-swiper");
  if (bannerCardsSwiper) {
    new Swiper(bannerCardsSwiper, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      speed: 500,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  }
}
const bgSwiper = new Swiper(".logos-carousel__bg-group", {
  slidesPerView: 1,
  speed: 800,
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  allowTouchMove: false
});
const contentSwiper = new Swiper(".logos-carousel__inner", {
  slidesPerView: 1,
  speed: 800,
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  autoHeight: true
});
const logos = document.querySelectorAll(".logos-carousel__logo");
logos.forEach((logo, index) => {
  logo.addEventListener("click", () => {
    contentSwiper.slideTo(index);
    bgSwiper.slideTo(index);
  });
});
function setActiveLogo(index) {
  logos.forEach(logo => logo.classList.remove("active"));
  logos[index].classList.add("active");
}
contentSwiper.on("slideChange", () => {
  setActiveLogo(contentSwiper.activeIndex);
});
document.querySelectorAll("[data-title]").forEach(btn => {
  btn.addEventListener("mousemove", e => {
    const rect = btn.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width * 100;
    const y = (e.clientY - rect.top) / rect.height * 100;
    btn.style.setProperty("--x", `${x}%`);
    btn.style.setProperty("--y", `${y}%`);
  });
});
const btnModal = document.querySelectorAll(".btn-modal");
btnModal.forEach(btn => {
  btn.addEventListener("click", event => {
    event.preventDefault();
    const modal = document.querySelector(btn.getAttribute("href"));
    modal.classList.add("open");
    document.body.style.overflow = "hidden";
    if (smoother) smoother.paused(true);
    const modalSwiper = new Swiper(modal.querySelector(".swiper"), {
      speed: 600,
      spaceBetween: 0,
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const modals = document.querySelectorAll(".modal");
  const modalsWrapper = document.querySelector(".modals-wrapper");
  modals.forEach(modal => {
    modalsWrapper.appendChild(modal);
    const modalClose = modal.querySelector(".modal__close");
    modalClose.addEventListener("click", () => {
      modal.classList.remove("open");
      document.body.style.overflow = "auto";

      // Reanudar ScrollSmoother al cerrar el modal
      if (smoother) smoother.paused(false);
      const modalSwiper = modal.querySelector(".swiper");
      modalSwiper.destroy();
    });
  });
});